import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { WidgetAccessService } from '@core/services';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MenuComponent {
  relatedRoute = input<string[]>([]);
  canAccessHomePage = computed<boolean>(() => {
    return this.widgetAccessService.hasAccessibleWidgets() || this.widgetAccessService.hasAccesOnlyToProductLinks();
  });
  configurationSubMenuOpen = signal<boolean>(false);
  constructor(
    private readonly widgetAccessService: WidgetAccessService,
    private readonly router: Router,
  ) {
    this.configurationSubMenuOpen.set(
      this.router.url.includes('vpn-configuration') || this.router.url.includes('departments') || false,
    );
  }

  buildRoute(path: string[]) {
    return ['/', ...this.relatedRoute(), ...path];
  }

  toggleConfigurationSubMenu() {
    this.configurationSubMenuOpen.set(!this.configurationSubMenuOpen());
  }
}
